// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import GenerateLettersModal from './data'

export default function GenerateLettersModalFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/GenerateLettersModal">
      <GenerateLettersModal {...props}>
        {children}
      </GenerateLettersModal>
    </Flow>
  )
}
